import React, { useState, useMemo, createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { useCreateBillingItemFilterFromAvailableToBillFilter } from './hooks/useCreateBillingItemFilterFromAvailableToBillFilter';

export const AddLineItemsDialogContext = createContext();

export const useLineItemsDialogContext = () =>
  useContext(AddLineItemsDialogContext);

export const LineItemsSearchContextProvider = ({
  availableToBillEndDate,
  availableToBillStartDate,
  availableToBillItemType,
  availableToBillProject,
  projectUri,
  projectName,
  children,
  ...props
}) => {
  const searchState = useCreateBillingItemFilterFromAvailableToBillFilter({
    availableToBillProject,
    availableToBillEndDate,
    availableToBillStartDate,
    availableToBillItemType,
    projectUri,
    projectName
  });
  const [searchCriteria, setSearchCriteria] = useState(searchState);

  const values = useMemo(
    () => ({
      searchCriteria,
      setSearchCriteria,
      ...props
    }),
    [props, searchCriteria]
  );

  return (
    <AddLineItemsDialogContext.Provider value={values}>
      {children}
    </AddLineItemsDialogContext.Provider>
  );
};
LineItemsSearchContextProvider.propTypes = {
  children: PropTypes.node,
  availableToBillProject: PropTypes.object,
  availableToBillEndDate: PropTypes.object,
  availableToBillStartDate: PropTypes.object,
  availableToBillItemType: PropTypes.object,
  projectUri: PropTypes.string,
  projectName: PropTypes.string
};

export default LineItemsSearchContextProvider;
